import GenericPage from '../page-generic';
import image from '../../assets/FaRegClock.svg';

export default function OutOfServicePage() {
	return (
		<GenericPage
			title={'Kiosk Out of Service'}
			message={'The kiosk is currently out of service. Please check back later.'}
			imageSrc={image}
			imageAlt={'Out of Service'}
		/>
	);
}
